import { useState } from 'react'
import { FileuploadPickerProvider } from './context/Provider'
import { FileuploadPickerContextValues } from './context/FileuploadPickerContext'
import FileuploadPickerModal from './components/FileuploadPickerModal'
import FileuploadPickerButton from './components/UploadButton'
import { FileWrapper, Step } from './types/types'

type FileUploadPickerProps = {
  onChange: (files: FileWrapper[]) => void
  maxSizeInBytes?: number | undefined
  accept?: string
  reject?: string
}

const DEFAULT_MAX_SIZE_IN_BYTES = 1_000_000_000 // 1 GB default

const FileUploadPicker = ({
  onChange,
  maxSizeInBytes = DEFAULT_MAX_SIZE_IN_BYTES,
  accept,
  reject,
}: FileUploadPickerProps) => {
  if (accept && reject) {
    throw new Error(
      'FileUploadPicker Error: You cannot use both "accept" and "reject" props at the same time. Please choose one.'
    )
  }

  const [files, setFiles] = useState<FileWrapper[]>([])
  const [showModal, setShowModal] = useState(false)
  const [step, setStep] = useState<Step>(Step.LOCAL)

  const [archiveListPagination, setArchiveListPagination] = useState<{
    page: number
    pageSize: number
  }>({
    page: 0,
    pageSize: 5,
  })

  const [archiveSearchListPagination, setArchiveSearchListPagination] =
    useState<{
      page: number
      pageSize: number
    }>({
      page: 0,
      pageSize: 5,
    })

  const [archiveSearchText, setArchiveSearchText] = useState<string>('')

  const onFilesChanged = (newFiles: FileWrapper[]) => {
    setFiles((prevFiles) => [...prevFiles, ...newFiles])
  }

  const onCloseModal = () => {
    setFiles([])
    setShowModal(false)
    setStep(Step.LOCAL)
  }

  const onSaveModal = () => {
    onChange(files)
    onCloseModal()
  }

  const onRemoveFile = (file: FileWrapper) => {
    setFiles((prevFiles) => prevFiles.filter((f) => f.id !== file.id))
  }

  const fileuploadPickerContextValue: FileuploadPickerContextValues = {
    files: files,
    accept: accept,
    reject: reject,
    maxsizeInBytes: maxSizeInBytes,
    onChange: onFilesChanged,
    removeFile: onRemoveFile,
    showModal: showModal,
    onCloseModal: onCloseModal,
    step: step,
    setStep: setStep,
    onSaveModal: onSaveModal,
    archiveListPagination: archiveListPagination,
    setArchiveListPagination: setArchiveListPagination,
    archiveSearchText: archiveSearchText,
    setArchiveSearchText: setArchiveSearchText,
    archiveSearchListPagination: archiveSearchListPagination,
    setArchiveSearchListPagination: setArchiveSearchListPagination,
  }

  return (
    <FileuploadPickerProvider value={fileuploadPickerContextValue}>
      <div>
        <FileuploadPickerButton onClick={() => setShowModal(true)} />
      </div>
      <FileuploadPickerModal />
    </FileuploadPickerProvider>
  )
}

export default FileUploadPicker
